<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { ProductLink } from './ProductLink';

    interface Props {
        link: ProductLink;
        onClick?: (event: Event) => void;
        children?: Snippet;
    }

    const { link, onClick, children }: Props = $props();
</script>

{#if link.index}
    <oc-link-v2 base64-href={btoa(link.detailPageLink)}>
        <a
            onclick={onClick}
            title={link.title}
            href={link.href}
            class="reptile-product-title__link"
            data-link-type="text"
            data-qa="find_tile__productLink"
        >
            {@render children?.()}
        </a>
    </oc-link-v2>
{:else}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <oc-link-v2
        base64-href={btoa(link.detailPageLink)}
        onclick={onClick}
        title={link.title}
        data-link-type="text"
        data-qa="find_tile__productLink"
    >
        <span class="reptile-product-title__link">
            {@render children?.()}
        </span>
    </oc-link-v2>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-title__link {
        display: block;
        color: tokens.$oc-semantic-color-text-default;
        text-align: left;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
</style>
